import { create } from 'zustand';

import { AddressInput } from 'src/clients/Network/gql/types/address';
import { Event, track } from 'src/clients/tracking';
import { ShippingOptionType } from 'src/views/creditApplication/ShippingAddress/ShippingAddressPage';

export type ErrorModalReason =
  | 'signup-recaptcha-failed'
  | 'user-creation-failed'
  | 'login-recaptcha-failed'
  | 'login-missing-access-token'
  | 'login-failed'
  | 'unexpected-exception';

type Store = {
  globalErrorAlertOpen: boolean;
  identityId?: string;
  creditApplicationId?: string;
  personalInformation: {
    firstName?: string;
    lastName?: string;
    email?: string;
    e164?: string;
    dateOfBirth?: string; // formatted as MM/DD/YYYY
    ssn?: string;
    incomeMicro?: number;
    monthlyHousingExpenseMicro?: number;
    residentialAddress?: AddressInput;
    shippingAddress?: AddressInput;
  };
  shippingMethod?: ShippingOptionType;
};

const initialState = {
  globalErrorAlertOpen: false,
  identityId: undefined,
  creditApplicationId: undefined,
  personalInformation: {
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    e164: undefined,
    dateOfBirth: undefined, // formatted as MM/DD/YYYY
    ssn: undefined,
    incomeMicro: undefined,
    residentialAddress: undefined,
    shippingAddress: undefined,
  },
  shippingMethod: undefined,
};

export const useGlobalStore = create<Store>()(() => ({
  ...initialState,
}));

export const showGlobalErrorAlert = (reason?: ErrorModalReason) => {
  if (!useGlobalStore.getState().globalErrorAlertOpen) {
    track(Event.RhWebCreditApplicationErrorModalShown, { reason });
  }
  useGlobalStore.setState({ globalErrorAlertOpen: true });
};

export const closeGlobalErrorAlert = () => {
  useGlobalStore.setState({ globalErrorAlertOpen: false });
};
